import { emptySubject, GradeActions } from '../../helpers/gradeOptions';

export default {
  name: 'KnAuthorizationMiniGradeItem',
  components: {},
  mixins: [],
  props: {
    subject: {
      type: Object,
      default: () => emptySubject,
    },
    disablePause: {
      type: Boolean,
      default: false,
    },
    disableAccept: {
      type: Boolean,
      default: false,
    },
    disableReject: {
      type: Boolean,
      default: false,
    },
    disableEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    grade() {
      return this.subject && this.subject.grade ? this.subject.grade : null;
    },
    colorStatus() {
      switch (this.grade.estatus_calificacion.dato) {
        case 'En revisión':
          return 'primary';
        case 'Aprobada':
          return 'success';
        case 'Rechazada':
          return 'error';
        default:
          return 'graydefault';
      }
    },
  },
  created() {},
  methods: {
    emitPause() {
      this.$emit('onPause', {
        ...this.grade,
        ...this.subjectStudentSimple,
        action: GradeActions.PAUSE,
      });
    },
    emitAccept() {
      this.$emit('onAccept', {
        ...this.grade,
        action: GradeActions.ACCEPT,
      });
    },
    emitReject() {
      this.$emit('onReject', {
        ...this.grade,
        action: GradeActions.REJECT,
      });
    },
    emitEdit() {
      this.$emit('onEdit', {
        ...this.grade,
        action: GradeActions.EDIT,
      });
    },
    emitDetail() {
      this.$emit('onDetail', {
        ...this.grade,
        action: GradeActions.DETAIL,
      });
    },
  },
};
